import React from 'react';

const About = () => {
  const styles = {
    container: {
      backgroundColor: '#ffffff',
      color: '#333333',
      minHeight: '100vh',
      padding: '4rem 2rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      lineHeight: '1.6'
    },
    content: {
      maxWidth: '900px',
      margin: '0 auto',
    },
    header: {
      textAlign: 'center',
      marginBottom: '3rem',
      borderBottom: '2px solid #000000',
      paddingBottom: '1.5rem'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: '#000000',
      marginBottom: '0.5rem'
    },
    subtitle: {
      fontSize: '1.2rem',
      color: '#555555',
      fontWeight: '300'
    },
    section: {
      marginBottom: '3rem'
    },
    sectionTitle: {
      fontSize: '1.8rem',
      fontWeight: '600',
      color: '#000000',
      borderBottom: '1px solid #eeeeee',
      paddingBottom: '0.5rem',
      marginBottom: '1.5rem'
    },
    paragraph: {
      marginBottom: '1.5rem',
      fontSize: '1.1rem'
    },
    skillsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '1rem',
      marginBottom: '2rem'
    },
    skill: {
      backgroundColor: '#f5f5f5',
      padding: '0.5rem 1rem',
      borderRadius: '20px',
      fontSize: '0.9rem',
      color: '#333333'
    },
    timeline: {
      position: 'relative',
      paddingLeft: '2rem',
      marginLeft: '1rem'
    },
    timelineItem: {
      position: 'relative',
      paddingBottom: '2rem'
    },
    timelineMarker: {
      position: 'absolute',
      left: '-1.7rem',
      top: '0',
      width: '1.2rem',
      height: '1.2rem',
      borderRadius: '50%',
      backgroundColor: '#000000'
    },
    timelineContent: {
      paddingLeft: '1rem'
    },
    timelineDate: {
      fontWeight: '500',
      color: '#555555',
      marginBottom: '0.5rem'
    },
    timelineTitle: {
      fontWeight: '600',
      fontSize: '1.2rem',
      marginBottom: '0.5rem'
    },
    downloadButton: {
      display: 'inline-block',
      backgroundColor: '#000000',
      color: '#ffffff',
      padding: '12px 24px',
      borderRadius: '4px',
      textDecoration: 'none',
      fontWeight: '600',
      fontSize: '1rem',
      marginTop: '2rem',
      transition: 'background-color 0.3s ease',
      cursor: 'pointer',
      border: 'none',
      '&:hover': {
        backgroundColor: '#333333'
      }
    },
    buttonContainer: {
      textAlign: 'center',
      marginTop: '3rem'
    }
    ,
      viewButton: {
      display: 'inline-block',
      backgroundColor: '#f5f5f5',
      color: '#000000',
      padding: '12px 24px',
      borderRadius: '4px',
      textDecoration: 'none',
      fontWeight: '600',
      fontSize: '1rem',
      marginTop: '2rem',
      transition: 'background-color 0.3s ease',
      cursor: 'pointer',
      border: '1px solid #dddddd',
      marginLeft: '1rem',
      '&:hover': {
        backgroundColor: '#eeeeee'
      }
    },
    buttonContainer: {
      textAlign: 'center',
      marginTop: '3rem',
      display: 'flex',
      justifyContent: 'center',
      gap: '1rem'
    }
  };

  const handleDownloadCV = () => {
    window.open('https://drive.google.com/uc?id=1WSBDgU4a2TrCf0QwuS_Fq-ppu7Pq17hb&export=download', '_blank');
  };

  const handleViewCV = () => {
    window.open('https://drive.google.com/file/d/1WSBDgU4a2TrCf0QwuS_Fq-ppu7Pq17hb/view?usp=drivesdk', '_blank');
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <header style={styles.header}>
          <h1 style={styles.title}>عبدالرحمن محرز</h1>
          <p style={styles.subtitle}>مطور برمجيات متخصص في تطوير التطبيقات والمواقع</p>
        </header>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>نبذة عني</h2>
          <p style={styles.paragraph}>
            أنا مطور برمجيات متمرس حاصل على درجة البكالوريوس في تقنية المعلومات، أمتلك خبرة تزيد عن  سنتان في مجال تطوير البرمجيات. أتخصص في بناء تطبيقات ويب وتطبيقات الهاتف ذات الأداء العالي والقابلة للتطوير.
          </p>
          <p style={styles.paragraph}>
            شغفي بالبرمجة بدأ منذ الصغر، وأؤمن بقوة التكنولوجيا في تغيير العالم. أسعى دائماً لتعلم التقنيات الحديثة وتطبيق أفضل الممارسات في مجال الهندسة البرمجية.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>المهارات التقنية</h2>
          <div style={styles.skillsContainer}>
            {/* أساسيات التطوير */}
            <span style={styles.skill}>JavaScript (ES6+)</span>
            {/* <span style={styles.skill}>TypeScript</span> */}
            <span style={styles.skill}>HTML5 & CSS3</span>

            {/* تطوير الواجهات الأمامية */}
            <span style={styles.skill}>React.js</span>
            <span style={styles.skill}>Next.js</span>
            {/* <span style={styles.skill}>Redux</span> */}
            <span style={styles.skill}>Tailwind CSS</span>

            {/* تطوير الواجهات الخلفية */}
            <span style={styles.skill}>Node.js</span>
            <span style={styles.skill}>Express</span>
            <span style={styles.skill}>RESTful APIs</span>

            {/* قواعد البيانات */}
            <span style={styles.skill}>MongoDB</span>
            <span style={styles.skill}>MySQL</span>
            <span style={styles.skill}>Firebase</span>

            {/* التحكم بالإصدارات والنشر */}
            <span style={styles.skill}>Git & GitHub</span>
            <span style={styles.skill}>GitLab</span>
            {/* <span style={styles.skill}>CI/CD</span> */}

            {/* تطوير التطبيقات */}
            <span style={styles.skill}>Flutter</span>
            <span style={styles.skill}>Dart</span>
            {/* <span style={styles.skill}>PWA</span> */}

            {/* أدوات أخرى */}
            {/* <span style={styles.skill}>Jest</span> */}
            {/* <span style={styles.skill}>Webpack</span> */}
            <span style={styles.skill}>Postman</span>
          </div>
        </section>


       <section style={styles.section}>
  <h2 style={styles.sectionTitle}>رحلة التطوير</h2>
  <div style={styles.timeline}>

    {/* 🔥 الجديد 2026 */}
    <div style={styles.timelineItem}>
      <div style={styles.timelineMarker}></div>
      <div style={styles.timelineContent}>
        <div style={styles.timelineDate}>2026 - الحاضر</div>
        <h3 style={styles.timelineTitle}>مطور مستقل (Freelancer)</h3>
        <p style={styles.paragraph}>
          - العمل كمطور مستقل في تطوير مواقع الويب وتطبيقات الموبايل<br />
          - تنفيذ مشاريع حقيقية للعملاء بجودة احترافية<br />
          - إدارة السيرفرات ورفع ونشر المواقع (Deployment)<br />
          - تحسين أداء المواقع وتجربة المستخدم<br />
          - تحسين محركات البحث (SEO) لزيادة الظهور في Google<br />
          - تعلم ومواكبة أحدث التقنيات في مجال البرمجة بشكل مستمر
        </p>
      </div>
    </div>

    <div style={styles.timelineItem}>
      <div style={styles.timelineMarker}></div>
      <div style={styles.timelineContent}>
        <div style={styles.timelineDate}>2025 - الحاضر</div>
        <h3 style={styles.timelineTitle}>خريج تقنية المعلومات - جامعة العلوم الحديثة</h3>
        <p style={styles.paragraph}>
          - متخصص في تطوير الويب والتطبيقات <br />
          - تنفيذ مشروع تخرج متكامل لنظام إدارة الحضور باستخدام MERN Stack<br />
          - تطوير تطبيقات ويب متكاملة باستخدام React.js وNode.js<br />
          - تطوير تطبيقات موبايل متكاملة باستخدام Flutter وDart<br />
          - بناء منصات إلكترونية تفاعلية ذات واجهات مستخدم متقدمة<br />
          - تطوير واجهات برمجة التطبيقات (APIs) آمنة وقابلة للتوسع
        </p>
      </div>
    </div>

    <div style={styles.timelineItem}>
      <div style={styles.timelineMarker}></div>
      <div style={styles.timelineContent}>
        <div style={styles.timelineDate}>2023 - 2025</div>
        <h3 style={styles.timelineTitle}>مرحلة التخصص الأكاديمي</h3>
        <p style={styles.paragraph}>
          - دراسة متعمقة في هندسة البرمجيات وتطوير التطبيقات<br />
          - إتمام مشاريع عملية في تطوير الويب والجوال<br />
          - تطوير مهارات في قواعد البيانات وتصميم الأنظمة<br />
        </p>
      </div>
    </div>

    <div style={styles.timelineItem}>
      <div style={styles.timelineMarker}></div>
      <div style={styles.timelineContent}>
        <div style={styles.timelineDate}>2022 - 2023</div>
        <h3 style={styles.timelineTitle}>المرحلة التأسيسية</h3>
        <p style={styles.paragraph}>
          - تأسيس قاعدة معرفية قوية في علوم الحاسوب<br />
          - تعلم أساسيات البرمجة والخوارزميات<br />
          - دراسة هياكل البيانات وتحليل الأنظمة<br />
          - تطوير أولى التطبيقات البرمجية البسيطة<br />
          - اكتساب مهارات حل المشكلات البرمجية
        </p>
      </div>
    </div>

  </div>
</section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>التعليم</h2>
          <div style={styles.timeline}>
            <div style={styles.timelineItem}>
              <div style={styles.timelineMarker}></div>
              <div style={styles.timelineContent}>
                <div style={styles.timelineDate}>2021 - 2025</div>
                <h3 style={styles.timelineTitle}>بكالوريوس في تقنية المعلومات</h3>
                <p style={styles.paragraph}>
                  جامعة العلوم الحديثة<br />
                  تخصص: هندسة البرمجيات<br />
                  {/* التقدير: امتياز مع مرتبة الشرف<br /> */}
                  مشروع التخرج: نظام إدارة الحضور المتكامل باستخدام MERN Stack
                </p>
              </div>
            </div>

            <div style={styles.timelineItem}>
              <div style={styles.timelineMarker}></div>
              <div style={styles.timelineContent}>
                <div style={styles.timelineDate}>2023 - 2024</div>
                <h3 style={styles.timelineTitle}>دبلوم متوسط في اللغة الإنجليزية</h3>
                <p style={styles.paragraph}>
                  معهد وترفورد للغات<br />
                  المستوى: متقدم (WIT3)<br />
                  التخصص: الإنجليزية التقنية<br />
                  {/* الدورات: كتابة التقارير الفنية - التواصل المهني - المصطلحات التقنية */}
                </p>
              </div>
            </div>
          </div>
        </section>

       <section style={styles.section}>
  <h2 style={styles.sectionTitle}>المشاريع البارزة</h2>
  <div style={styles.timeline}>

    {/* 🔥 مشروع شاهين بلس */}
    <div style={styles.timelineItem}>
      <div style={styles.timelineMarker}></div>
      <div style={styles.timelineContent}>
        <h3 style={styles.timelineTitle}>منصة شاهين بلس - العقارات والمزادات</h3>
        <p style={styles.paragraph}>
          - منصة إلكترونية متكاملة لبيع وشراء الأراضي الكبيرة وإدارة المزادات العقارية<br />
          - تتيح للمستخدمين استعراض العقارات والدخول في مزادات مباشرة بشكل آمن وسهل<br />
          - تقنيات مستخدمة: React.js, Node.js, MongoDB, APIs<br />
          - ميزات فريدة:<br />
          &nbsp;&nbsp;• إدارة متكاملة للعقارات (إضافة، تعديل، أرشفة)<br />
          &nbsp;&nbsp;• نظام توثيق المستخدمين لزيادة الموثوقية<br />
          &nbsp;&nbsp;• واجهات استخدام سهلة ومتجاوبة لجميع الأجهزة<br />
          &nbsp;&nbsp;• تحسين الأداء وتجربة المستخدم لعرض سريع للعقارات<br />
          - رابط المشروع:<br />
          &nbsp;&nbsp;https://shaheenplus.sa/
        </p>
        <div style={styles.techTags}>
          <span style={{ ...styles.tag, marginRight: '10px' }}>React</span>
          <span style={{ ...styles.tag, marginRight: '10px' }}>Node.js</span>
          <span style={{ ...styles.tag, marginRight: '10px' }}>MongoDB</span>
          <span style={{ ...styles.tag, marginRight: '10px' }}>API</span>
        </div>
      </div>
    </div>

    {/* 🔥 مشروع نافس برو */}
    <div style={styles.timelineItem}>
      <div style={styles.timelineMarker}></div>
      <div style={styles.timelineContent}>
        <h3 style={styles.timelineTitle}>منصة نافس برو - إدارة الاختبارات التعليمية</h3>
        <p style={styles.paragraph}>
          - منصة تعليمية متكاملة لإدارة الاختبارات ومراجعة الطلاب بشكل احترافي<br />
          - تمكّن المعلمين من إنشاء اختبارات إلكترونية ومتابعة أداء الطلاب وتحليل النتائج<br />
          - تقنيات مستخدمة: React.js, Node.js, MongoDB<br />
          - ميزات فريدة:<br />
          &nbsp;&nbsp;• إنشاء اختبارات إلكترونية بسهولة<br />
          &nbsp;&nbsp;• نظام تصحيح تلقائي وتقييم فوري<br />
          &nbsp;&nbsp;• تقارير تحليلية لأداء الطلاب<br />
          &nbsp;&nbsp;• لوحة تحكم للإدارة والمعلمين<br />
          &nbsp;&nbsp;• تجربة مستخدم سلسة للطلاب على مختلف الأجهزة<br />
          - رابط المشروع:<br />
          &nbsp;&nbsp;https://nafspro.org/
        </p>
        <div style={styles.techTags}>
          <span style={{ ...styles.tag, marginRight: '10px' }}>React</span>
          <span style={{ ...styles.tag, marginRight: '10px' }}>Node.js</span>
          <span style={{ ...styles.tag, marginRight: '10px' }}>MongoDB</span>
          <span style={styles.tag}>API</span>
        </div>
      </div>
    </div>

    {/* باقي مشاريعك الحالية 👇 */}

            {/* مشروع نظام الحضور والانصراف */}
            <div style={styles.timelineItem}>
              <div style={styles.timelineMarker}></div>
              <div style={styles.timelineContent}>
                <h3 style={styles.timelineTitle}>نظام الحضور والانصراف الذكي</h3>
                <p style={styles.paragraph}>
                  - نظام متكامل للتحكم في حضور الموظفين باستخدام البصمة والموقع الجغرافي<br />
                  - تقنيات مستخدمة: React.js, Node.js, MongoDB, IoT (انترنت الأشياء)<br />
                  - ميزات فريدة:<br />
                  &nbsp;&nbsp;• مصادقة متعددة العوامل (بصمة + موقع جغرافي)<br />
                  &nbsp;&nbsp;• تكامل مع أجهزة البلوتوث عبر IoT<br />
                  &nbsp;&nbsp;• تقارير حضور مفصلة مع خرائط جغرافية<br />
                  &nbsp;&nbsp;• تنبيهات فورية للتسجيل المخالف<br />
                  - نتائج المشروع المتوقعة: <br />
                  &nbsp;&nbsp;• خفض التغيب بنسبة 40%<br />
                  &nbsp;&nbsp;• تقليل الأخطاء في كشوف المرتبات بنسبة 95%<br />
                  {/* &nbsp;&nbsp;• زيادة الشفافية في سجلات الحضور والانصراف بنسبة 100%<br /> */}
                  {/* &nbsp;&nbsp;• تحسين إنتاجية الموظفين بنسبة تصل إلى 25%<br /> */}
                  &nbsp;&nbsp;• توفير وقت إداري يصل إلى 30 ساعة شهرياً<br />
                  &nbsp;&nbsp;• تقليل الاحتيال في نظام الحضور بنسبة 99%<br />
                  &nbsp;&nbsp;• تحسين تجربة الموظفين مع نظام حضور سهل الاستخدام<br />
                  &nbsp;&nbsp;• توفير بيانات تحليلية لاتخاذ قرارات الموارد البشرية<br />
                </p>
                <div style={styles.techTags}>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>React</span>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>Node.js</span>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>MongoDB</span>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>IoT</span>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>API</span>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>Firebase</span>

                  <span style={styles.tag}>Flutter</span>
                </div>
              </div>
            </div>

            {/* مشروع مساعدة المريض */}
            <div style={styles.timelineItem}>
              <div style={styles.timelineMarker}></div>
              <div style={styles.timelineContent}>
                <h3 style={styles.timelineTitle}>نظام مساعدة المريض المتكامل</h3>
                <p style={styles.paragraph}>
                  - منصة ذكية متكاملة لإدارة الرحلات العلاجية للمرضى<br />
                  - تقنيات مستخدمة: Flutter, Node.js, MongoDB, Firebase<br />
                  - ميزات فريدة:<br />
                  &nbsp;&nbsp;• نظام حجز متكامل (طيران - فنادق - مواصلات)<br />
                  &nbsp;&nbsp;• تتبع الرحلات الجويه <br />
                  &nbsp;&nbsp;• تكامل مع أنظمة المستشفيات ومراكز التشخيص<br />
                  &nbsp;&nbsp;• حجز وجبات  بسهوله تامه   <br />
                  {/* &nbsp;&nbsp;• تنبيهات تلقائية لمواعيد  <br /> */}
                  - نتائج المشروع المتوقعة: <br />
                  {/* &nbsp;&nbsp;• خدمة أكثر من 5,000 مريض سنوياً<br /> */}
                  &nbsp;&nbsp;• توفير 60% من وقت تنظيم الرحلة العلاجية<br />
                  &nbsp;&nbsp;• تقليل التكاليف الإدارية بنسبة 45%<br />
                  {/* &nbsp;&nbsp;• تكامل مع 50+ مستشفى و100+ فندق<br /> */}
                  {/* &nbsp;&nbsp;• رضا المرضى بنسبة 98% عن الخدمة<br /> */}
                  &nbsp;&nbsp;• تقليل الأخطاء في الحجوزات بنسبة 90%<br />
                  {/* &nbsp;&nbsp;• توفير 30 ساعة أسبوعياً للفريق الطبي<br /> */}
                </p>
                <div style={styles.techTags}>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>React</span>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>Node.js</span>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>MongoDB</span>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>IoT</span>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>API</span>
                  <span style={{ ...styles.tag, marginRight: '10px' }}>Firebase</span>

                  <span style={styles.tag}>Flutter</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>الشهادات</h2>
          <div style={styles.paragraph}>
            - شهادة البكالوريوس في هندسة البرمجيات (2024-2025)<br />
            - شهادة WIT (مستوى متقدم في الإنجليزية) (2025)<br />
            - شهادة التدريب العملي من شركة سابا فون (2025)<br />
          </div>
        </section>

     <div style={styles.buttonContainer}>
          <button 
            style={styles.downloadButton}
            onClick={handleDownloadCV}
          >
            تحميل السيرة الذاتية (PDF)
          </button>
          <button 
            style={styles.viewButton}
            onClick={handleViewCV}
          >
            عرض السيرة الذاتية
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;
